import {CFValue} from 'module/CustomField/type/CFType'

// null to empty string
export function ntes(val: CFValue) {
	return val == null ? '' : (val + '')
}